module.exports = __webpack_public_path__ + "static/media/galerija_2022_0004.f94067f0.jpg";